import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const RegistrationRecord = Record({
  isLicensingEnabled: false,
  isRegistered: false,
  isReadOnlyMode: false,
  isTrialStarted: false,
  isTrialExpired: false,
  emailAddress: null,
  licenseCode: null,
  expiryDate: null,
  disablePurchasing: false
});

// Custom implementation to force numbers to boolean, since they will have been broken
createFromJS.registerCallback("RegistrationRecord", any => {
  return new RegistrationRecord(any).merge({
    isLicensingEnabled: Boolean(any.isLicensingEnabled),
    isRegistered: Boolean(any.isRegistered),
    isReadOnlyMode: Boolean(any.isReadOnlyMode),
    isTrialStarted: Boolean(any.isTrialStarted),
    isTrialExpired: Boolean(any.isTrialExpired),
    expiryDate: any.expiryDate ? any.expiryDate : null,
    disablePurchasing: Boolean(any.disablePurchasing),
  });
});
